import { ArrowUpRight } from "lucide-react";

const projects = [
  ["Fernblick / Svizzera", "Osso Cross Cut · pannelli scanalati", "https://www.poggibros.it/wp-content/uploads/2024/03/RET_7665-1-scaled.jpg.webp"],
  ["Brown's Avenue / Lisbona", "Aree comuni in Travertino Romano", "https://www.poggibros.it/wp-content/uploads/2022/07/NAM_2442.jpg.webp"],
  ["The Stone House / Fiano Romano", "Interni ed esterni in travertino", "https://www.poggibros.it/wp-content/uploads/2023/10/38-I-Stonehouse-I-Fiano-Romano-RM-I-2022-I-%C2%A9CarloOriente2022-edited.jpg"],
];

export default function ProjectGallery() {
  return (
    <section className="projects-section" id="archivio" data-testid="project-gallery-section">
      <div className="site-container">
        <div className="project-heading reveal"><div><span className="eyebrow">07 / Archivio opere</span><h2>Quando la pietra<br /><i>diventa spazio.</i></h2></div><a className="text-link" href="#contatti">Parliamo del tuo progetto <ArrowUpRight size={16} /></a></div>
        <div className="project-grid">
          {projects.map(([place, title, image], index) => (
            <figure className={`project-item project-item-${index + 1} reveal reveal-delay-${index + 1}`} key={title}>
              <div className="project-image"><img src={image} alt={title} loading="lazy" /></div>
              <figcaption><span>{place}</span><strong>{title}</strong></figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
